<template>
  <div class="file-upload">
    <input
      type="file"
      :accept="accept"
      :multiple="multiple"
      @change="uploadFile"
    >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'FileUploader',
  props: {
    accept: {
      type: String,
      default: '',
    },
    formats: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    uploadFile({ target }) {
      const files = Array.from(target.files);
      const promises = files.map(file => this.readFile(file));
      return Promise.all(promises)
        .then(result => this.$emit('load', result))
        .catch((error) => {
          this.$rollbar.error(error);
          this.$emit('error', error);
        });
    },
    readFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        if (!this.formats.includes(file.type)) {
          reject(new Error('Invalid file format'));
        }

        reader.onload = () => {
          if (file.type === 'application/json') {
            try {
              resolve(JSON.parse(reader.result));
            } catch (error) {
              reject(error);
            }
          } else resolve(reader.result);
        };

        reader.onerror = (error) => {
          reader.abort();
          reject(error);
        };

        reader.readAsText(file);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.file-upload {
  position: relative;

  input {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }
}
</style>
